import { NavLink } from 'react-router-dom';
import { cn } from '@v2/utils/cn';
import { isSuperAdmin } from '@v2/lib/auth';
import { useI18n } from '@v2/providers/I18nProvider';

export default function UsersAdminTabs() {
    const { t } = useI18n();

    const tabs = [
        { to: '/users',               label: t('v2.nav.users'),               end: true },
        { to: '/roles-permissions',   label: t('v2.nav.roles_permissions'),   end: true },
        ...(isSuperAdmin()
            ? [{ to: '/settings/login-security', label: t('v2.nav.login_security'), end: true as const }]
            : []),
    ];

    return (
        <nav className="mb-6 flex flex-wrap gap-1 rounded-lg border border-gray-200 bg-gray-50/80 p-1 dark:border-gray-700/60 dark:bg-gray-800/40">
            {tabs.map((tab) => (
                <NavLink
                    key={tab.to}
                    to={tab.to}
                    end={tab.end}
                    className={({ isActive }) =>
                        cn(
                            'rounded-md px-4 py-2 text-sm font-medium transition',
                            isActive
                                ? 'bg-white text-gray-900 shadow-sm ring-1 ring-gray-200 dark:bg-gray-700 dark:text-gray-100 dark:ring-gray-600'
                                : 'text-gray-600 hover:bg-white/60 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700/50 dark:hover:text-gray-200',
                        )
                    }
                >
                    {tab.label}
                </NavLink>
            ))}
        </nav>
    );
}
